const hasTags = ({ state, props, path }) => {
  const tags = state.get(`selectr.${props.namespace}.selected`)
  if (tags.length > 0) {
    return path.true()
  } else {
    return path.false()
  }
}

hasTags.displayName = 'hasTags'
export default hasTags
